


























import Vue from "vue";
import ModelView from "@/components/model-view.vue";
import { uuidToInstanceId } from "@/utils/uuid-to-instance-id";
import { recombinateComponentDetail } from "@/utils/recombinate-component-detail";
import { getComponentInformation } from "@/api/model-view";
import RightMenu from "@/features/simulation-right-menu/index.vue";
import SimulationLeftMenu from "@/features/simulation-left-menu/index.vue";
import SimulationPanel from "@/features/simulation-panel/index.vue";
import { SimulationType } from "@/constants/custom-simulation";
import { safeJsonParse } from "@/utils/safe-json-parse";
import { generateComponentDetail } from "@/utils/generate-component-detail";
import { strToInt32 } from "@/utils/str-to-int32";
import Exercises from "../../features/exercises/index.vue";

export default Vue.extend({
    data() {
        return { loading: true, entered: false, clickedInstanceId: 0 };
    },
    computed: {
        modelId(): string {
            return this.$store.state.customSimulationModule.currentSimulationResource?.uploadFile
                ?.fileId || '0';
        },
        loadingImageSrc(): string {
            return safeJsonParse(
                this.$store.state.customSimulationModule.currentSimulationDetail.find(
                    v => v.classType === SimulationType.loadingPage
                ).viewSettings
            ).filePath;
        },
        drawingId(): string {
            return this.$store.state.customSimulationModule.currentSimulationResource.viewFile
                ?.fileId;
        },
        api3d() {
            return this.$store.getters["modelViewModule/api3d"];
        },
        isCurrentFinish() {
            return (
                this.$store.state.customSimulationModule.currentSimulation.step ===
                this.$store.state.customSimulationModule.currentSimulationDetail.length - 2
            );
        },
        isPrevStep() {
            return (
                this.$store.state.customSimulationModule.selectedSimulationDetail.sort <
                this.$store.state.customSimulationModule.currentSimulation.step + 2
            );
        },
        currentSimulationType(): SimulationType {
            return this.$store.state.customSimulationModule.currentSimulationResource?.designFile?.classType || SimulationType.exercises;
        },
        isTwoDimensionalAndThreeDimensionalComparison(): boolean {
            return (
                this.currentSimulationType ===
                SimulationType.twoDimensionalAndThreeDimensionalComparison
            );
        },
        isExercises(): boolean {
            return this.currentSimulationType === SimulationType.exercises;
        }
    },
    methods: {
        async handleClickComponent(uuid) {
            const currentSelectedComponents = this.api3d.getSelectedElementGuids().map(strToInt32);
            if (currentSelectedComponents.length === 1) {
                const instanceId = currentSelectedComponents[0];
                const res = await getComponentInformation({
                    modelId: this.modelId,
                    instanceId,
                });
                if (res.status.error !== 0) {
                    this.$message.error(res.status.errorDesc);
                    return;
                }
                const componentDetails = generateComponentDetail(res.instanceProperty.propertySets);
                this.$store.commit('simulationRightMenuModule/setComponentInformations', {
                    name: res.instanceProperty.name,
                    details: componentDetails,
                });
            } else {
                this.$store.commit('simulationRightMenuModule/setComponentInformations', {
                    name: '',
                    details: [],
                });
            }
            this.$store.commit('customSimulationModule/setSelectedInstanceId', [
                ...currentSelectedComponents,
            ]);
            (this.$refs.RightMenu as any).$refs.StructureTree.$refs.tree.setCheckedKeys([]);
        },
        handleLoaded(benchId) {
            this.$store.commit("modelViewModule/setBenchId", benchId);
            const { viewSettings } = this.$store.state.customSimulationModule.currentSimulationResource.designFile;
            (window as any).spdengine.Apis.getApi(benchId)["3D"].setCurrentLook(viewSettings);
            console.log(viewSettings);
            this.loading = false;
        },
        twoDimensionLoaded(benchId) {
            this.$store.commit("modelViewModule/set2DBenchId", benchId);
        },
        handleCheck(uuids) {
            this.api3d.restoreHighLightRenderElement();
            uuids.forEach(v => this.api3d.highLightRenderElement(v));
        },
        async nextStep() {
            this.api3d && this.api3d.removeAllMarkerDeviceInfo();
            this.$store.dispatch("customSimulationModule/setNextSimulationDetail");
        },
        async finish() {
            this.$store.dispatch("customSimulationModule/changeLearningStatus", {
                designTaskId: this.$store.state.customSimulationModule.currentSimulation.id,
                status: 2,
                targetId: this.$store.state.user.userId,
                step: this.$store.state.customSimulationModule.currentSimulation.step
            });
            this.$router.back();
        }
    },
    components: { ModelView, RightMenu, SimulationLeftMenu, SimulationPanel, Exercises }
});
